import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
import Api from '../../../services/api';
import { toast } from "react-toastify";
import withRouter from "../../../services/withRouter";
import {EmailIcon, FacebookShareButton, TwitterShareButton, FacebookIcon, EmailShareButton, XIcon, WhatsappShareButton, PinterestIcon, PocketIcon, TelegramIcon, TwitterIcon, WhatsappIcon,
} from "react-share";

class BusinessRelatedScheme extends React.Component {
    
  
    componentDidMount = async () => {
        window.scrollTo(0, 0);
        this.getScheme();
    };



    getScheme = async()=>{
        var scheme_id = await this.props.params.id;
        if(scheme_id){
            var response = await Api.GetRequest({}, 'scheme/'+scheme_id);
            if(response.status == 200){
                this.setState({'scheme' : response.scheme});
            }
            else{
                toast.error("Something went wrong. Please try again later.");
            }
        }
        else{
            this.props.navigate(-1)
        }
       
    }
  

    constructor(props) {
        super(props);
        this.state = {
            'scheme' : {
                'description' : "",
                'mode_of_application' : "",
                'eligibility' : "",
                'required_documents' : "",
                'web_links' : "",
                'description_height' : "",
                'eligibility_height' : "",
                'required_document_height' : "",
                'mode_of_application_height' : "",
                'web_links_height' : ""
            }
        };
        this.description_ref = React.createRef()
        this.eligibility_ref = React.createRef()
        this.required_documents_ref = React.createRef()
        this.mode_of_application_ref = React.createRef()
        this.web_links_ref = React.createRef()
    }

    
    setDescriptionHeight = async()=>{
        var height = this.description_ref.current.contentWindow.document.body.scrollHeight + 50;
        this.setState({'description_height' : height + "px"});
    }

    setEligibilityHeight = async()=>{
        var height = this.eligibility_ref.current.contentWindow.document.body.scrollHeight + 50;
        this.setState({'eligibility_height' : height + "px"});
    }

    setRequiredDocumentsHeight = async()=>{
        var height = this.required_documents_ref.current.contentWindow.document.body.scrollHeight + 50;
        this.setState({'required_document_height' : height + "px"});
    }

    setModeOfApplicationHeight = async()=>{
        var height = this.mode_of_application_ref.current.contentWindow.document.body.scrollHeight + 50;
        this.setState({'mode_of_application_height' : height + "px"});
    }

    setWebLinksHeight = async()=>{
        var height = this.web_links_ref.current.contentWindow.document.body.scrollHeight + 50;
        this.setState({'web_links_height' : height + "px"});
    }

    render(){

        return(
            <>
                <div class="m-0 shadow"  style={{'width' : '100vw!important', 'maxWidth' : '100vw!important'}}>
                    <div class="row mx-0">
                        <div class="col-lg-12">
                            <div class="commn_banner_page" style={{'position' : 'relative'}}>
                                <img src={process.env.REACT_APP_SERVER + this.state.scheme.banner}/>
                                <h2 className="text-center mb-0" style={{'position' : 'absolute', 'top' : '40%', 'left' : '10%', 'color' : '#000000', "textTransform" : "uppercase"}}>{this.state.scheme.title}</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <section id="news_details_main">
                    <div class="container">
                        <div class="row" id="counter">
                            <div class="col-lg-8">
                                <div class="details_wrapper_area">
                                   
                                    <div class="details_text_wrapper text-start">
                                        
                                        <iframe  onLoad={()=>{this.setDescriptionHeight()}} scrolling="no" frameBorder="0" height={this.state.description_height} srcDoc={this.state.scheme.description} ref={this.description_ref}  style={{'width':'100%'}}/>
                                        
                                        {this.state.scheme.eligibility &&
                                            <>
                                                <h3 className="my-2">Eligibility</h3>
                                                <iframe  onLoad={()=>{this.setEligibilityHeight()}} scrolling="no" frameBorder="0" height={this.state.eligibility_height} srcDoc={this.state.scheme.eligibility} ref={this.eligibility_ref}  style={{'width':'100%'}}/>
                                            </>
                                        }
                                        {this.state.scheme.required_documents &&
                                            <>
                                                <h3 className="my-2">Required Documents</h3>
                                                <iframe  onLoad={()=>{this.setRequiredDocumentsHeight()}} scrolling="no" frameBorder="0" height={this.state.required_document_height} srcDoc={this.state.scheme.required_documents} ref={this.required_documents_ref}  style={{'width':'100%'}}/>
                                            </>
                                        }
                                        {this.state.scheme.mode_of_application &&
                                            <>
                                                <h3 className="my-2">Mode Of Application</h3>
                                                <iframe  onLoad={()=>{this.setModeOfApplicationHeight()}} scrolling="no" frameBorder="0" height={this.state.mode_of_application_height} srcDoc={this.state.scheme.mode_of_application} ref={this.mode_of_application_ref}  style={{'width':'100%'}}/>
                                            </>
                                        }
                                        {this.state.scheme.web_links &&
                                            <>
                                                <h3 className="my-2">Web link</h3>
                                                <iframe  onLoad={()=>{this.setWebLinksHeight()}} scrolling="no" frameBorder="0" height={this.state.web_links_height} srcDoc={this.state.scheme.web_links} ref={this.web_links_ref}  style={{'width':'100%'}}/>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="sidebar_first">
                                    <div class="share_causes_wrapper sidebar_boxed">
                                        <div class="sidebar_heading_main">
                                            <h3>Share</h3>
                                        </div>
                                        <div class="social_icon_sidebar">
                                            <ul>
                                                <FacebookShareButton url={window.location.href} className="mx-2">
                                                    <FacebookIcon size={32} round  bgStyle={{fill:'#000000'}} />
                                                </FacebookShareButton>

                                                <TwitterShareButton url={window.location.href} className="mx-2"  title={this.state.scheme.title}>
                                                    <XIcon size={32} round  bgStyle={{fill:'#000000'}} />
                                                </TwitterShareButton>

                                                <EmailShareButton url={window.location.href} className="mx-2"  subject={this.state.scheme.title} body="body">
                                                    <EmailIcon size={32} round  bgStyle={{fill:'#000000'}} />
                                                </EmailShareButton>

                                                <WhatsappShareButton url={window.location.href} className="mx-2"  title={this.state.scheme.title} separator=":: ">
                                                    <WhatsappIcon size={32} round  bgStyle={{fill:'#000000'}} />
                                                </WhatsappShareButton>
                                               
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}


export default withRouter(BusinessRelatedScheme)